import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";
import createSagaMiddleware from "redux-saga";
import AppReducer from "./AppReducers";
import "regenerator-runtime/runtime";
import logger from "redux-logger";
import storage from "redux-persist/lib/storage";
import { ENVIRONMENT } from "../utils/Constant";
import { configureStore } from "@reduxjs/toolkit";

const sagaMiddleware = createSagaMiddleware();
const middlewares = [sagaMiddleware];

if (process.env.REACT_APP_ENVIRONMENT === ENVIRONMENT.development) {
  middlewares.push(logger);
}

const persistConfig = {
  key: "root",
  storage,
  whitelist: ["auth", "voucher"],
  timeout: 5000,
};

const persistedReducer = persistReducer(persistConfig, AppReducer);
let store = undefined;

const configStore = () => {
  store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        serializableCheck: {
          ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
          ignoredActionPaths: [
            "payload.formHandler",
            "payload.callBack",
            "formAutorizacionDiagnosticoData.alertConfig.onConfirm",
            "formAutorizacionDiagnosticoData.alertConfig.onCancel",
            "formCierreCuentasData.alertConfig.onConfirm",
            "formCierreCuentasData.alertConfig.onCancel",
            "formConsultaCierresCuentasData.alertConfig.onConfirm",
            "formConsultaCierresCuentasData.alertConfig.onCancel",
          ],
        },
      }).concat(...middlewares),
  });
  const persistor = persistStore(store);
  return {
    persistor,
    runSaga: sagaMiddleware.run,
    store,
  };
};

export default configStore;

export { store };
